import { useEffect, useRef } from 'react';
import { Grid, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { isEmpty } from 'lodash';

import { getOrdersByPage } from 'store/thunks/ordersListThunk';
import { getPartners } from 'store/thunks/partnerThunks';
import { listShippingOptions } from 'store/thunks/batchShipmentThunk';
import OrdersFilterButton from './components/ordersFilterButton';
import OrdersTable from './components/ordersTable';
import OrderFilterStatusBar from './components/OrderFilterStatusBar';

const OrdersList = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPage = useSelector(({ ordersList }) => ordersList.currentPage);
  const partners = useSelector(({ auth, partner }) => partner[auth.currentTenantId]);
  const shippingOptions = useSelector(({ systemConfigs }) => systemConfigs?.shippingOptions || []);

  const isEmptyPartners = isEmpty(partners);
  const isEmptyShippingOptions = isEmpty(shippingOptions);

  const hasCalledApiRef = useRef(false);
  const previousPathnameRef = useRef(location.pathname);

  useEffect(() => {
    document.title = 'Orders - SmartOS';
  }, []);

  useEffect(() => {
    if (previousPathnameRef.current !== location.pathname && location.pathname === '/orders') {
      hasCalledApiRef.current = false;
    }
    previousPathnameRef.current = location.pathname;

    if (!hasCalledApiRef.current) {
      hasCalledApiRef.current = true;
      dispatch(getOrdersByPage({ page: currentPage }));
    }
  }, [dispatch, currentPage, location.pathname]);

  useEffect(() => {
    if (isEmptyPartners) {
      dispatch(getPartners());
    }
  }, [dispatch, isEmptyPartners]);

  useEffect(() => {
    if (isEmptyShippingOptions) {
      dispatch(listShippingOptions());
    }
  }, [dispatch, isEmptyShippingOptions]);

  return (
    <Grid container sx={{ px: 3, pt: 2 }} direction='column'>
      <Grid item container justifyContent='space-between'>
        <Typography component='h1' variant='h5'>
          Orders
        </Typography>

        <Grid item>
          <OrdersFilterButton />
        </Grid>
      </Grid>

      <Grid item sx={{ minHeight: 40, pb: 2, pt: 2 }} container alignItems='center'>
        <OrderFilterStatusBar />
      </Grid>

      <Grid item>
        <OrdersTable />
      </Grid>
    </Grid>
  );
};

export default OrdersList;
